import { Button, ButtonGroup } from "@mui/material";
import colors from "../../theme/themeConstants";
import { ReactComponent as DisplayGridIcon } from "../icons/displayGridIcon.svg";
import { ReactComponent as DisplayRowIcon } from "../icons/displayRowIcon.svg";

interface IProps {
  rowView: boolean;
  toggleFn: () => void;
}

const GridRowViewToggler = ({ rowView, toggleFn }: IProps) => {
  const fullOpacity = 1;
  const halfOpacity = 0.6;

  return (
    <ButtonGroup
      id="grid-row-view-button-group"
      sx={{
        borderColor: colors.selectGreyBorder,
        borderStyle: "solid",
        maxHeight: "36px",
        borderRadius: "8px",
        borderWidth: "1px",
        "& button": {
          border: "none !important",
          borderRadius: "7px",
          padding: "10px 12px"
        },
        "& :hover": {
          backgroundColor: "var(--selectGreyBorder)"
        }
      }}>
      <Button onClick={toggleFn} disabled={!rowView && true}
        sx={{
          opacity: !rowView ? fullOpacity : halfOpacity,
          backgroundColor: rowView ? colors.backgroundBlack : "var(--selectGreyBorder)",
          transition: "all .3s ease",
          "&:hover": {
            opacity: 1
          }
        }}>
        <DisplayGridIcon style={{ height: "16px", width: "auto" }} />
      </Button>
      <Button onClick={toggleFn} disabled={rowView && true}
        sx={{
          opacity: rowView ? fullOpacity : halfOpacity,
          backgroundColor: rowView ? "var(--selectGreyBorder)" : colors.backgroundBlack,
          transition: "all .3s ease",
          "&:hover": {
            opacity: 1
          }
        }}>
        <DisplayRowIcon style={{ height: "16px", width: "auto" }} />
      </Button>
    </ButtonGroup>
  );
};

export default GridRowViewToggler;
